module.exports = __webpack_public_path__ + "img/bosscode.2096be22.png";